import Typography from '@material-ui/core/Typography';

const TreeItemLabelText = ({ children, onClick, noWrap = false }) => (
  <Typography noWrap={ noWrap } variant="body2" onClick={ onClick }>
    {children}
  </Typography>
);

export default TreeItemLabelText;
